export default "__VITE_ASSET__BK539INr__"